// API Configuration
// Uses REACT_APP_API_URL environment variable if set, otherwise uses relative path (same domain)
// This avoids mixed content issues (HTTPS page trying to fetch HTTP)

const API_URL = process.env.REACT_APP_API_URL || '/api';

export default API_URL;

